import Vue from "vue";
import VueI18n from "vue-i18n";
import pl from "./locales/pl";
import en from "./locales/en";

Vue.use(VueI18n);

const messages = {
  en,
  pl,
};

const i18n = new VueI18n({
  locale: "en",
  messages,
});

export default i18n;
